import { createActorContext } from '@xstate/react';

import { personMachine } from './person-machine';

export const PersonMachineContext = createActorContext(personMachine);
